import React from "react";
import PropTypes from "prop-types";
import MoreOptionDailog from "./MoreOptionDailog";
import { Link } from "react-router-dom";
import { lighten, makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TextField from "@material-ui/core/TextField";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Container from "@material-ui/core/Container";
import InspectionPopup from "../Inspection/inspectionPopup";
import { useHistory } from "react-router-dom";
import { Redirect } from "react-router";
import GlobalApi from "./../../Global";
import Colors from "./../../Global/colors";
import DarkButton from "../../Global/DarkButton";
import refresh_token from "./../../Global/refresh_token";
import Spinner from "./../../Global/Spinner";
import EditIcon from "@material-ui/icons/Edit";
import StartIcon from "@material-ui/icons/Check";
import NoRecords from "./../../Global/NoRecords";
function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  { id: "name", numeric: false, disablePadding: false, label: "Title" },
  {
    id: "description",
    numeric: false,
    disablePadding: false,
    label: "Description",
  },
  { id: "status", numeric: true, disablePadding: false, label: "Status" },
  { id: "scheduled", numeric: true, disablePadding: false, label: "Scheduled" },
  // {
  //   id: "modified",
  //   numeric: true,
  //   disablePadding: false,
  //   label: "Modified On",
  // },
  { id: "shared", numeric: true, disablePadding: false, label: "Shared" },
];

function EnhancedTableHead(props) {
  const {
    classes,
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead className="" style={{ background: "#f5f5f5" }}>
      <TableRow>
        {/* <TableCell padding="checkbox">
          <Checkbox />
        </TableCell> */}
        {headCells.map((headCell) => (
          <TableCell
            style={{ padding: 10 }}
            key={headCell.id}
            align={headCell.numeric === true ? "center" : "left"}
            padding={headCell.disablePadding ? "none" : "default"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            {/* <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            > */}
            <Typography style={{ color: Colors.buttonTextColor }}>
              {headCell.label}
            </Typography>
            {orderBy === headCell.id ? (
              <span className={classes.visuallyHidden}>
                {order === "desc" ? "sorted descending" : "sorted ascending"}
              </span>
            ) : null}
            {/* </TableSortLabel> */}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === "light"
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  title: {
    flex: "1 1 100%",
  },
}));

const EnhancedTableToolbar = (props) => {
  const classes = useToolbarStyles();
  const { numSelected } = props;

  return "";
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    backgroundColor: Colors.backgroundColor,
    marginTop: 10,
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
    padding: 10,
    margin: 10,
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
}));

export default function EnhancedTable() {
  const classes = useStyles();
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("calories");
  const [selected, setSelected] = React.useState([]);
  const [searchText, setSearchText] = React.useState("");
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [rows, setRows] = React.useState(null);
  const [currentUser, setCurrentUser] = React.useState({});
  let history = useHistory();

  React.useEffect(() => {
    //getInspection();
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    setCurrentUser(data);
    getTemplates();
  }, []);

  const getInspection = () => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      user_id: data.user_id,
    };
    console.log(data.user_id);
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/Inspection/get_all_inspections_share?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        if (response.status === "Success") {
          if (response.data) {
            setRows(response.data);

            // setInspection(response.data);
            console.log(response, "{}{}{}{}");
          }
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            console.log("opopopop");
            getInspection();
          }
        }
      })
      .catch((error) => console.log(error.message));
    console.log("op");
  };
  const getTemplates = async (templateId) => {
    var retrievedData = localStorage.getItem("UserData");
    var data = JSON.parse(retrievedData);
    if (data == undefined) {
      return <Redirect to={"/signin"} />;
    }

    //this.setState({loader:true})
    var params = {
      organization_id: data.organization_id,
      user_id: data.user_id,
    };
    var token = data.token;
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");
    await fetch(
      GlobalApi + "/TemplateShare/get_all_template_shares_for_user?" + query,
      {
        method: "GET",
        headers: new Headers({
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        }),
      }
    )
      .then((response) => response.json())
      .then(async (res) => {
        if (res.status === "Success") {
          console.log(res.data);
          var result = res.data;
          var templateList = [];
          await result.map((data) => {
            var template = {
              id: data.id,
              name: data.title,
              description: data.description,
              scheduled: data.Schedules?.length > 0 ? "Yes" : "no",
              modified: "",
              shared: data.TemplateShares?.length > 1 ? "Yes" : "no",
              createdBy: data.created_by,
              createdAt: data.createdAt,
              status: data.status,
              TemplateShares: data.TemplateShares,
              created_by: data.created_by,
            };
            templateList.push(template);
          });
          //this.setState({rows:templateList,loader:false})
          setRows(
            templateList.sort(
              (a, b) =>
                new Date(b.createdAt).getTime() -
                new Date(a.createdAt).getTime()
            )
          );
        } else if (
          res.error === "jwt expired" ||
          res.error === "invalid token" ||
          res.error === "invalid signature" ||
          res.error == "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
          }
        }
      })
      .catch((err) => {
        //alert(err)
        console.log(err, "error");
      });
  };
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // const handleChangeDense = (event) => {
  //   setDense(event.target.checked);
  // };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, rows?.length - page * rowsPerPage);
  const ModalOpen = (row) => {
    setIsModalOpen(row);
  };
  if (rows == null) {
    return <Spinner />;
  } else {
    return (
      <Container className={classes.root}>
        <Grid container justify="left">
          <Grid item xs={12}>
            {/* <Typography
              variant="h4"
              style={{
                fontWeight: "500",
                color: Colors.buttonTextColor,
                textAlign: "left",
              }}
            >
              Templates
            </Typography> */}
          </Grid>
          <Grid item xs={12} sm={12} md={10}>
            <TextField
              id="outlined-basic"
              label="Search"
              autoComplete="off"
              fullWidth
              onChange={(e) => setSearchText(e.target.value)}
              variant="outlined"
            />
          </Grid>
          <Grid md={2} align="right" style={{ alignSelf: "center" }}>
            {/* <div style={{ display: "flex", justifyContent: "flex-end" }}> */}
            <Link to="/template-editor/create">
              <DarkButton>New Template</DarkButton>
            </Link>
            {/* </div> */}
          </Grid>
        </Grid>
        <Paper variant="outlined" style={{ marginTop: 17 }}>
          <EnhancedTableToolbar numSelected={selected.length} />
          <TableContainer>
            <Table
              className={classes.table}
              aria-labelledby="tableTitle"
              // padding="none"
              aria-label="enhanced table"
            >
              <EnhancedTableHead
                classes={classes}
                numSelected={selected.length}
                order={order}
                orderBy={orderBy}
                onRequestSort={handleRequestSort}
                rowCount={rows.length}
              />
              <TableBody>
                {rows.length !== 0 ? (
                  stableSort(
                    rows.filter((v) =>
                      v.name?.toLowerCase().includes(searchText?.toLowerCase())
                    ),
                    getComparator(order, orderBy)
                  )
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => {
                      const isItemSelected = isSelected(row.name);
                      const labelId = `enhanced-table-checkbox-${index}`;

                      return (
                        <TableRow
                          hover
                          onClick={(event) => handleClick(event, row.name)}
                          role="checkbox"
                          aria-checked={isItemSelected}
                          tabIndex={-1}
                          key={row.id}
                          className="testingtable new-hover"
                        >
                          {/* <TableCell padding="checkbox">
                          <Checkbox
                            checked={isItemSelected}
                            inputProps={{ "aria-labelledby": labelId }}
                          />
                        </TableCell> */}
                          <TableCell
                            component="th"
                            id={labelId}
                            scope="row"
                            padding="none"
                            // align="right"
                            style={{ padding: 12, minWidth: 200 }}
                          >
                            <Typography variant="p"> {row.name} </Typography>
                          </TableCell>

                          <TableCell style={{ padding: 12 }}>
                            <Typography variant="p">
                              {row.description}
                            </Typography>
                          </TableCell>
                          <TableCell
                            style={{ padding: 12, textAlign: "center" }}
                          >
                            <Typography variant="p"> {row.status} </Typography>
                          </TableCell>
                          {/* <TableCell style={{ padding: 12 }}>
                            Yes
                          </TableCell> */}
                          <TableCell
                            style={{ padding: 12, textAlign: "center" }}
                          >
                            <Typography variant="p">{row.scheduled}</Typography>
                          </TableCell>
                          <TableCell
                            style={{ padding: 12, textAlign: "center" }}
                          >
                            <Typography variant="p"> {row.shared} </Typography>
                          </TableCell>

                          <div
                            className="hover-div1 pointer-cursor"
                            // style={{ textAlign: "right" }}
                          >
                            <React.Fragment>
                              <div
                                className="text-center"
                                onClick={() =>
                                  history.push({
                                    pathname: "/schedule-create",
                                    state: { template_id: row.id },
                                  })
                                }
                              >
                                <StartIcon />
                                <br />
                                Start Schedule
                              </div>
                            </React.Fragment>

                            <div
                              className="text-center"
                              style={{
                                background:
                                  row.created_by === currentUser.user_id ||
                                  (row.TemplateShares.filter(
                                    (v) => v.user_id === currentUser.user_id
                                  )[0] &&
                                    row.TemplateShares.filter(
                                      (v) => v.user_id === currentUser.user_id
                                    )[0]?.isEditor === true)
                                    ? "389fd0"
                                    : "lightgray",
                              }}
                              onClick={() => {
                                console.log(
                                  row.created_by === currentUser.user_id,
                                  row.TemplateShares.filter(
                                    (v) => v.user_id === currentUser.user_id
                                  )[0],
                                  row.TemplateShares.filter(
                                    (v) => v.user_id === currentUser.user_id
                                  )[0]?.isEditor === true,

                                  row.created_by === currentUser.user_id ||
                                    row.TemplateShares.filter(
                                      (v) => v.user_id === currentUser.user_id
                                    )[0] !== undefined
                                    ? row.TemplateShares.filter(
                                        (v) => v.user_id === currentUser.user_id
                                      )[0]?.isEditor === true
                                    : false
                                );

                                if (
                                  row.created_by === currentUser.user_id
                                    ? true
                                    : row.TemplateShares.filter(
                                        (v) => v.user_id === currentUser.user_id
                                      )[0] !== undefined
                                    ? row.TemplateShares.filter(
                                        (v) => v.user_id === currentUser.user_id
                                      )[0]?.isEditor === true
                                    : false
                                ) {
                                  history.push({
                                    pathname: "/show",
                                    state: {
                                      action: "edit",
                                      templateId: row.id,
                                    },
                                  });
                                  // history.push({
                                  //   pathname: "/edit-template",
                                  //   state: {
                                  //     action: "edit",
                                  //     templateId: row.id,
                                  //   },
                                  // });
                                } else {
                                }
                              }}
                            >
                              <EditIcon />
                              <br />
                              Edit
                            </div>
                            {/* <div
                            className="text-center"
                            // onClick={() => ModalOpen(row)}
                          >
                            <MoreHorizIcon />
                            <br />
                            More Option
                          </div> */}

                            <MoreOptionDailog
                              template_id={row.id}
                              getTemplates={getTemplates}
                              created_by={row.created_by}
                            />
                          </div>
                        </TableRow>
                      );
                    })
                ) : (
                  <TableRow>
                    <TableCell colSpan={6}>
                      <NoRecords />
                    </TableCell>
                  </TableRow>
                )}
                {/* {emptyRows > 0 && (
                  <TableRow style={{ height: (dense ? 33 : 53) * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )} */}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            // style={{backgroundColor: }}
            rowsPerPageOptions={[5, 10]}
            component="div"
            count={rows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
          />
        </Paper>

        <br />
        <br />
        <br />
        <br />
        <br />
        <br />

        {isModalOpen && (
          <InspectionPopup
            isModalOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
          />
        )}
      </Container>
    );
  }
}
